import { CRASH_REPORT_LIMITS } from "../../shared/crashReports/schema.js";

const URL_QUERY = /((?:https?:)?\/\/[^\s?#"'<>()]+)\?[^\s"'<>()]*/g;

const redactQueryStrings = (text) => text.replace(URL_QUERY, "$1?[redacted]");

const fit = (field, text) =>
  redactQueryStrings(text).slice(0, CRASH_REPORT_LIMITS[field]);

const asText = (value) => (typeof value === "string" ? value : "");

const isErrorLike = (value) => typeof value?.message === "string";

const errorFields = (error) =>
  isErrorLike(error)
    ? {
        name: asText(error.name) || "Error",
        message: error.message,
        stack: asText(error.stack),
      }
    : { name: "NonError", message: String(error), stack: "" };

export const crashReportFrom = ({
  error,
  componentStack,
  section,
  location,
  navigator,
  release,
  now,
}) => {
  const { name, message, stack } = errorFields(error);

  return {
    message: fit("message", message),
    name: fit("name", name),
    stack: fit("stack", stack),
    componentStack: fit("componentStack", asText(componentStack)),
    section: fit("section", section),
    path: fit("path", location.pathname),
    browserLanguage: fit("browserLanguage", asText(navigator.language)),
    userAgent: fit("userAgent", asText(navigator.userAgent)),
    release: fit("release", asText(release)),
    occurredAt: new Date(now).toISOString(),
  };
};
